<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-analytics-model-stats-page" v-loading="loading" element-loading-text="Loading...">
    <div class="header-text">
      <span>
        <div class="wy-page-title-small">{{$t(currentPageInfo.subtitle)}}</div>
        <div class="wy-page-title">
          {{$t(currentPageInfo.title)}} <wy-page-tooltip />
        </div>
      </span>
    </div>
    <no-data-page v-show="!data||!data.modelStats||data.modelStats.totalSessions==undefined"> </no-data-page>
    <wy-analytics-stats-breakdown :controller="module"  :data="data" v-if='!loading && data && data.modelStats && data.modelStats.totalSessions' />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import wyAnalyticsStatsBreakdown from './wy-analytics-stats-breakdown';
import wyPageTooltip from '../widgets/wy-page-tooltip.vue';
import noDataPage from '../../views/PageNoDataWithAvailableDateRange';

export default Vue.extend({
  name: 'wy-analytics-model-stats-page',
  components: {
    'wy-analytics-stats-breakdown': wyAnalyticsStatsBreakdown,
    'wy-page-tooltip': wyPageTooltip,
    'no-data-page': noDataPage
  },

  data() {
    return {
      module: this,
      loading: false,
      data: null,
      selectedStat: "conversations"
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'config', 'currentPageInfo', 'isLoggedIn']),
  },

  methods: {
    ...mapActions(['fetchModelStats']),

    async handleFilterChange() {
      if((!this.loading && this.dataModel.dateEnd) || this.dataModel.dateEnd) {
        this.loading = true;

        let res = await this.fetchModelStats({selectedStat: this.selectedStat});
        // res.data = this.prepareModeData();
        if(res.status == 200) {
          this.loading = false;
          setTimeout(()=>{
            this.data = res.data;
          } ,100)
        }
      }
    },

    prepareModeData() {
      let data = {}
      data = {
        "modelStats": {
          "totalSessions": Math.floor(Math.random() * 10000),
          "totalInactiveSessions":  Math.floor(Math.random() * 10000),

          "totalConversations":  20,
          "totalConversationsPercent": 99.01,
          "totalConversationsCompare":  null,

          "totalConversationsWithATopic":  Math.floor(Math.random() * 10000),
          "totalConversationsWithATopicPercent":  Math.floor(Math.random() * 100),
          "totalConversationsWithATopicCompare":  null, //Math.floor(Math.random() * 100),

          "totalVAOriginatedConversations":  Math.floor(Math.random() * 10000),
          "totalVAOriginatedConversationsPercent":  Math.floor(Math.random() * 100),
          "totalVAOriginatedConversationsCompare":  null, //Math.floor(Math.random() * 100),

          "totalLiveAgentOnlyConversations":  Math.floor(Math.random() * 10000),
          "totalLiveAgentOnlyConversationsPercent":  Math.floor(Math.random() * 100),
          "totalLiveAgentOnlyConversationsCompare":  null, //Math.floor(Math.random() * 100),

          "totalVAEngagedConversations": Math.floor(Math.random() * 10000),
          "totalVAEngagedConversationsPercent":  Math.floor(Math.random() * 100),
          "totalVAEngagedConversationsCompare":  null, //Math.floor(Math.random() * 100),

          "totalVAConversationsWithImmedidate": Math.floor(Math.random() * 10000),
          "totalVAConversationsWithImmedidatePercent":  Math.floor(Math.random() * 100),
          "totalVAConversationsWithImmedidateCompare":  null, //Math.floor(Math.random() * 100),

          "totalVAContainedConversations": Math.floor(Math.random() * 10000),
          "totalVAContainedConversationsPercent":  Math.floor(Math.random() * 100),
          "totalVAContainedConversationsCompare":  null, //Math.floor(Math.random() * 100),

          "totalVAEngagedWithLiveAgentRequested":  Math.floor(Math.random() * 10000),
          "totalVAEngagedWithLiveAgentRequestedPercent":  Math.floor(Math.random() * 100),
          "totalVAEngagedWithLiveAgentRequestedCompare":  null, //Math.floor(Math.random() * 100),

          "totalVAEngagedWithLiveAgentConnected": Math.floor(Math.random() * 10000),
          "totalVAEngagedWithLiveAgentConnectedPercent":  Math.floor( Math.floor(Math.random() * 100)),
          "totalVAEngagedWithLiveAgentConnectedCompare":  null, //Math.floor( Math.floor(Math.random() * 100)),
        }
      }
      return data
    },

    refreshPage() {
      this.handleFilterChange();
    }
  },

  async created() {
    // listen events from other components
    this.$root.registerPageEvent(this.$route.name, (event) => {
      if(this[event.name]) this[event.name]();
    })    
    this.handleFilterChange();
  },

  mounted() {
    this.$root.registerTooltips(this.$el);
  },

  beforeDestroy() {
    this.$root.unregisterTooltips(this.$el);
  }
});
</script>

<style lang="scss">
  .wy-analytics-model-stats-page {
    min-width: 1080px; // 1130px;
    .el-loading-mask {
      height: calc(100vh - 120px) !important;
    }
    .el-loading-text {
      display: none;
    }
    .header-text {
    color: var(--site-font-secondary-color);
    font-size: 25px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 600;
      .el-icon-info {
        position: relative;
        left: 5px;
        bottom: 10px;
        line-height: 0;
        background-color: #ACB8C6;
        color: #214586;
        font-size: 15px;
        cursor: pointer;
      }

      .wy-page-title {
        margin-bottom: 0px;
        height: 25px;
        line-height: 0.7;
        .wy-page-tooltip .info-icon {
          top: 0px;
        }
      }

      .wy-page-title-small {
        display: none;
        color: var(--site-font-secondary-color);
        font-size: 15px;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-weight: 400;
      }
    }

    .annotation-text {
      font-weight: 600;
    }
  }
</style>